import type { GeneralBarDatum } from "@jana-technology/platform-ui";

export const xAccessor = (d: GeneralBarDatum) => d.x;
export const x1Accessor = (d: GeneralBarDatum) => d.x1!;
